import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'underscore'
import $ from 'jquery'
import {
  fetchCandidatesData,
  fetchTemplatesData,
  convertResumes,
  getCandidateAttachments,
  fetchTemplateConfigurations,
} from '../../actions/actions'
import { toggleResumeNameModal } from '../../actions/modals'
import CustomDropdown from '../components/CustomDropdown'
import Loader from '../components/Loader'
import '../../styles/_candidate_listing_container.scss'
import '../../styles/icons.scss'

const baseUrl = 'https://vmockvideofiles.s3.amazonaws.com/assets/images/'

const CandidateListing = () => {
  const candidatesData = useSelector((state) => state.candidatesData.data)
  const targetFileNames = useSelector((state) => state.targetFileNamesData)
  const templatesData = useSelector((state) => state.templatesData.data)
  const candidatesDataFetching = useSelector(
    (state) => state.candidatesData.fetching
  )
  const candidatesDataFetchedOnce = useSelector(
    (state) => state.candidatesData.fetchedOnce
  )
  const fileAttachmentsFetchedFor = useSelector(
    (state) => state.candidatesData.fileAttachmentsFetchedFor
  )
  const templatesDataFetching = useSelector(
    (state) => state.templatesData.fetching
  )
  const templatesDataFetchedOnce = useSelector(
    (state) => state.templatesData.fetchedOnce
  )
  const resumesDataFetching = useSelector((state) => state.resumesData.fetching)
  const conversionInProgress = useSelector(
    (state) => state.conversionInProgress
  )
  const filetypeTemplatesMapping = useSelector(
    (state) => state.templatesData.filetypeTemplatesMapping
  )
  const authToken = useSelector((state) => state.authToken)

  const [allCandidateData, setCandidatesData] = useState(candidatesData)
  const [allTemplatesData, setTemplatesData] = useState(templatesData)
  const [selectedCandidates, setSelectedCandidates] = useState(candidatesData)
  const [checkForDefaultResets, setCheckForDefaultResets] = useState(false)
  const [fileMenuOpenFor, setFileMenuOpenFor] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    if (authToken) {
      dispatch(fetchCandidatesData())
      dispatch(fetchTemplatesData())
    }
  }, [authToken])

  useEffect(() => {
    dispatch(fetchTemplateConfigurations())
  }, [])

  /* Handles candidates data fetch for the first time */
  useEffect(() => {
    if (!_.isEmpty(candidatesData)) {
      setCandidatesData(candidatesData)
      setSelectedCandidates(candidatesData)
    }
    if (
      !_.isEmpty(candidatesData) &&
      !_.isEmpty(templatesData) &&
      !checkForDefaultResets
    ) {
      setCheckForDefaultResets(true)
    }
  }, [candidatesDataFetchedOnce])

  /* Handles templates data fetch for the first time */
  useEffect(() => {
    if (!_.isEmpty(templatesData)) {
      setTemplatesData(templatesData)
    }
    if (
      !_.isEmpty(candidatesData) &&
      !_.isEmpty(templatesData) &&
      !checkForDefaultResets
    ) {
      setCheckForDefaultResets(true)
    }
  }, [templatesDataFetchedOnce])

  /* Handles file attachments data fetch for a candidate */
  useEffect(() => {
    if (fileAttachmentsFetchedFor) {
      setCandidatesData(
        appendFetchedFilesData(candidatesData, fileAttachmentsFetchedFor, 'all')
      )
      setSelectedCandidates(
        appendFetchedFilesData(
          candidatesData,
          fileAttachmentsFetchedFor,
          'selected'
        )
      )
    }
  }, [fileAttachmentsFetchedFor])

  /* Handles default selection of template & resume when either is null */
  useEffect(() => {
    if (checkForDefaultResets && !_.isEmpty(templatesData)) {
      if (!_.isEmpty(selectedCandidates)) {
        setSelectedCandidates(
          setTemplateAndAttachmentToFirst(selectedCandidates)
        )
      }
      if (!_.isEmpty(allCandidateData)) {
        setCandidatesData(setTemplateAndAttachmentToFirst(allCandidateData))
        setCheckForDefaultResets(false)
      }
    }
  }, [checkForDefaultResets])

  useEffect(() => {
    if (!_.isEmpty(targetFileNames)) {
      let updateAllCandidatesData = $.extend(true, [], allCandidateData),
        updateSelectedCandidatesData = $.extend(true, [], selectedCandidates)
      _.map(targetFileNames, (fileName, cIndex) => {
        let cId = parseInt(cIndex.split('_')[1])
        let cIndex1 = updateAllCandidatesData.findIndex((c) => c.id === cId),
          cIndex2 = updateSelectedCandidatesData.findIndex((c) => c.id === cId)
        if (updateAllCandidatesData[cIndex1]) {
          updateAllCandidatesData[cIndex1]['target_filename'] = fileName
        }
        if (updateSelectedCandidatesData[cIndex2]) {
          updateSelectedCandidatesData[cIndex2]['target_filename'] = fileName
        }
      })
      setSelectedCandidates(updateSelectedCandidatesData)
      setCandidatesData(updateAllCandidatesData)
    }
  }, [targetFileNames])

  const appendFetchedFilesData = (data, cId, key) => {
    let updatedData = $.extend(
        true,
        [],
        key === 'all' ? allCandidateData : selectedCandidates
      ),
      cIndexAll = data.findIndex((c) => c.id === cId),
      cIndexCurr = updatedData.findIndex((c) => c.id === cId)
    if (cIndexAll > -1 && cIndexCurr > -1) {
      let keysToUpdate = ['data', 'fetching', 'fetchedOnce']
      keysToUpdate.forEach((k) => {
        if (k === 'data') {
          updatedData[cIndexCurr].fileAttachments['data'] = $.extend(
            true,
            [],
            data[cIndexAll].fileAttachments['data']
          )
        } else {
          updatedData[cIndexCurr].fileAttachments[k] =
            data[cIndexAll].fileAttachments[k]
        }
      })
    }
    return updatedData
  }

  const setTemplateAndAttachmentToFirst = (data) => {
    let updatedData = $.extend(true, [], data)
    _.map(data, (item, index) => {
      if (!item.file_attachment_id && !_.isEmpty(item.fileAttachments.data)) {
        updatedData[index].file_attachment_id = item.fileAttachments.data[0].id
        updatedData[index].filename = item.fileAttachments.data[0].name
      }
      if (!item.template_id) {
        let selectedRes = item.fileAttachments.data.find(
          (res) => res.id === updatedData[index].file_attachment_id
        )
        if (
          !_.isEmpty(filetypeTemplatesMapping) &&
          selectedRes &&
          selectedRes.type &&
          !_.isEmpty(filetypeTemplatesMapping[selectedRes.type])
        ) {
          updatedData[index].template_id =
            filetypeTemplatesMapping[selectedRes.type][0]
        } else {
          updatedData[index].template_id = allTemplatesData[0].id
        }
      }
    })
    return updatedData
  }

  const enableConversion = (data) => {
    if (
      _.isEmpty(data) ||
      candidatesDataFetching ||
      templatesDataFetching ||
      conversionInProgress ||
      resumesDataFetching
    ) {
      return false
    }

    let isValid = true
    data.forEach((item) => {
      if (item.template_id == null || item.file_attachment_id == null) {
        isValid = false
      }
    })

    return isValid
  }

  const getSortedAttachmentOptions = (attachments) => {
    let options = []
    let sortedAttachments = $.extend(true, [], attachments)
    sortedAttachments.sort((a, b) => {
      return a.dateAdded < b.dateAdded ? -1 : a.dateAdded > b.dateAdded ? 1 : 0
    })
    sortedAttachments.forEach((attachment) => {
      let option = {}
      option.value = attachment.id
      option.label = attachment.name
      option.type = attachment.type
      options.push(option)
    })
    return options
  }

  const handleChange = (option, candidate_id, type) => {
    let candidateIndexSelected = selectedCandidates.findIndex(
        (item) => item.id === candidate_id
      ),
      candidateIndex = allCandidateData.findIndex(
        (item) => item.id === candidate_id
      )
    let candidate = $.extend(true, {}, allCandidateData[candidateIndex])
    if (type === 'template') {
      candidate['template_id'] = option.value
    } else if (type === 'file') {
      if (option.type) {
        if (!filetypeTemplatesMapping) {
        }
      }
      candidate['file_attachment_id'] = option.value
      candidate['filename'] = option.label
      if (
        !_.isEmpty(filetypeTemplatesMapping) &&
        candidate['template_id'] &&
        option.type &&
        !_.isEmpty(filetypeTemplatesMapping[option.type]) &&
        !filetypeTemplatesMapping[option.type].includes(
          candidate['template_id']
        )
      ) {
        candidate['template_id'] = null
      }
    }
    setCheckForDefaultResets(true)
    let updatedSelectedCandidates = $.extend(true, [], selectedCandidates),
      updateAllCandidatesData = $.extend(true, [], allCandidateData)
    if (candidateIndexSelected > -1) {
      updatedSelectedCandidates.splice(candidateIndexSelected, 1, candidate)
      setSelectedCandidates(updatedSelectedCandidates)
    }
    updateAllCandidatesData.splice(candidateIndex, 1, candidate)
    setCandidatesData(updateAllCandidatesData)
  }

  const getItemRow = (candidate, index) => {
    let candidateIndex = selectedCandidates.findIndex(
      (item) => item.id === candidate.id
    )
    let attachmentOptions = getSortedAttachmentOptions(
      candidate.fileAttachments.data
    )
    let fileName = candidate.target_filename ? candidate.target_filename : candidate.defaultTargetFileName
    let templates = $.extend(true, [], allTemplatesData),
      selectedTemplateOption = null
    if (candidate.template_id) {
      selectedTemplateOption = templates.find(
        (option) => option.value === candidate.template_id
      )
    }

    let formatGroupedAttachmentOptions = {},
      groupedOptions = [],
      selectedAttachmentOption = null
    _.map(attachmentOptions, (attachment) => {
      let option = {},
        type = attachment.type ? attachment.type : 'others'
      if (attachment.value === candidate.file_attachment_id) {
        selectedAttachmentOption = {
          value: attachment.value,
          label: attachment.label,
          type: attachment.type,
        }
      }
      option = {
        value: attachment.value,
        label: attachment.label,
        type: attachment.type,
      }
      if (!formatGroupedAttachmentOptions[type]) {
        formatGroupedAttachmentOptions[type] = []
      }
      formatGroupedAttachmentOptions[type].push(option)
    })
    _.map(formatGroupedAttachmentOptions, (group, key) => {
      groupedOptions.push({
        label: key,
        options: group,
      })
    })
    let othersGroupIndex = groupedOptions.findIndex(group => group.label === 'others')
    if (othersGroupIndex > -1) {
      let othersGroup = groupedOptions[othersGroupIndex]
      groupedOptions.splice(othersGroupIndex, 1)
      groupedOptions.push(othersGroup)
    }

    return (
      <div className={`candidate-list-item ${index === 0 ? 'mt-0' : ''}`}>
        <div className="list-cell list-cell-candidate-info w-20 tl">
          <div className="d-flex">
            <input
              tabIndex={0}
              type="checkbox"
              checked={candidateIndex > -1}
              onClick={() => {
                let updatedCandidates = $.extend(true, [], selectedCandidates)
                if (candidateIndex > -1) {
                  updatedCandidates.splice(candidateIndex, 1)
                } else {
                  updatedCandidates.push($.extend(true, {}, candidate))
                }
                setSelectedCandidates(updatedCandidates)
              }}
            />
            <div className="candidate-info">
              <div className="candidate-name">
                {candidate.firstName} {candidate.lastName}
              </div>
              {candidate.occupation ? (
                <div className="candidate-role">{candidate.occupation}</div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="list-cell list-cell-template-info w-30 tc">
          {!_.isEmpty(templates) ? (
            <div className="d-flex d-flex-center">
              <span className="prefix">Template:</span>
              <CustomDropdown
                options={templates}
                selectedOption={selectedTemplateOption}
                placeholder="Select Template"
                type="template"
                candidateId={candidate.id}
                handleChange={handleChange}
              />
            </div>
          ) : (
            'No Template'
          )}
        </div>
        <div className="list-cell list-cell-resume-info w-30 tc">
          {!_.isEmpty(attachmentOptions) || true ? (
            <div className="d-flex d-flex-center">
              <span className="prefix">Resume:</span>
              <CustomDropdown
                options={groupedOptions}
                selectedOption={selectedAttachmentOption}
                placeholder="Select Resume"
                type="file"
                candidateId={candidate.id}
                handleChange={handleChange}
                noOptionsMessage={
                  candidate.fileAttachments.fetching ||
                  !candidate.fileAttachments.fetchedOnce
                    ? 'Fetching ...'
                    : 'No Options'
                }
                customControlClick={() => {
                  if (!fileMenuOpenFor) {
                    setFileMenuOpenFor(candidate.id)
                  }
                  if (
                    !candidate.fileAttachments.fetchedOnce &&
                    !candidate.fileAttachments.fetching
                  ) {
                    dispatch(
                      getCandidateAttachments(
                        candidate.id,
                        candidate.file_attachment_id,
                        candidate.template_id
                      )
                    )
                  }
                }}
                onMenuClose={() => {
                  if (fileMenuOpenFor) {
                    setFileMenuOpenFor(null)
                  }
                }}
              />
              {(!fileMenuOpenFor || fileMenuOpenFor != candidate.id) &&
              !_.isEmpty(attachmentOptions) &&
              candidate.file_attachment_id &&
              selectedAttachmentOption &&
              selectedAttachmentOption.type ? (
                <div className="file-type-absolute">
                  File Type: {selectedAttachmentOption.type}
                </div>
              ) : null}
            </div>
          ) : (
            'No Resume'
          )}
        </div>
        <div className="list-cell list-cell-file-name w-20 tc">
          <div
            className="d-flex target-file-name"
            tabIndex="0"
            onClick={() => {
              dispatch(toggleResumeNameModal({ isOpen: true, candidateId: candidate.id, currentFileName: fileName }))
            }}
          >
            {fileName}
            <span className="icon-edit-1" />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="candidate-listing-container">
      <h4>Convert Resumes of following candidates using VMock</h4>
      <div className="listing-table-headers">
        <div className="header-cell w-20 tl">Candidate Name</div>
        <div className="header-cell w-30 tc">Selected Template</div>
        <div className="header-cell w-30 tc">Selected Resume</div>
        <div className="header-cell w-20 tc">Output Resume Name</div>
      </div>
      {templatesDataFetching || candidatesDataFetching ? (
        <Loader className={"align-top"}/>
      ) : !_.isEmpty(allCandidateData) ? (
        <div className="items-container no-scrollbar">
          {_.map(allCandidateData, (candidate, index) => {
            return getItemRow(candidate, index)
          })}
        </div>
      ) : (
        <div className="no-data-ui">
          <img src={`${baseUrl}no_conversions.svg`} />
          No candidates found!
        </div>
      )}
      <div className="bottom-button-container">
        <button
          onClick={() => {
            if (enableConversion(selectedCandidates)) {
              dispatch(convertResumes(selectedCandidates))
            }
          }}
          disabled={!enableConversion(selectedCandidates)}
        >
          Convert (
          {!_.isEmpty(selectedCandidates) ? selectedCandidates.length : 0})
        </button>
      </div>
    </div>
  )
}

export default CandidateListing
